module.exports = __webpack_public_path__ + "static/portfolio-image-9-77859ba09c80b557d480d42eb9f28550.jpg";